import React from 'react';

const FilterTabs = ({
  activeFilter,
  onFilterChange,
  totalCount,
  includedCount,
  excludedCount,
  totalIncludedExceptcredit,
  handleRegenrate
}) => {
  const tabs = [
    {
      id: 'all',
      label: 'All Accounts',
      icon: 'fa-filter',
      count: totalCount,
      className: 'all'
    },
    {
      id: 'include',
      label: 'Included',
      icon: 'fa-check-circle',
      count: includedCount,
      className: 'include'
    },
    {
      id: 'includeExceptcredit',
      label: 'Included Except Credit',
      icon: 'fa-check-circle',
      count: totalIncludedExceptcredit,
      className: 'includeExceptcredit'
    },
    {
      id: 'exclude',
      label: 'Excluded',
      icon: 'fa-times-circle',
      count: excludedCount,
      className: 'exclude'
    }
  ];

  return (
    <div className="filter-tabs">
      <div className="tabs-container">
        {tabs.map((tab) => {
          const isActive = activeFilter === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onFilterChange(tab.id)}
              className={`filter-tab ${isActive ? `active ${tab.className}` : ''}`}
            >
              <i className={`fa ${tab.icon}`}></i>
              <span>{tab.label}</span>
              <span className="tab-count">
                {tab.count}
              </span>
            </button>
          );
        })}

        <button
        onClick={()=>handleRegenrate()}
        className='filter-tab'
        style={{background:'#3b82f6',color:'#fff',marginLeft:'auto'}}
        >
          <i className={`fa fa-refresh`}></i>
          <span>Regenerate</span>

        </button>
      </div>
    </div>
  );
};

export default FilterTabs;